export default {
  stats: {
    orders: 'Bestellungen',
    sales: 'Einnahmen',
  },
};
